export default __webpack_public_path__ + "static/media/Category-20.b8e456a5.jpg";